import React, { useState, useEffect } from "react"; 
import axiosInstance from "../../../../Config/axiosInstance";
import "./AddContacts.css"; 

const EditContacts = ({ open, onClose, contact, onSave }) => {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    if (contact) {
      setName(contact.name);
      setRole(contact.position);
      setEmail(contact.email);
      setPhone(contact.phone);
    }
  }, [contact]);
  
  const handleSubmit = async () => {
    if (!name || !email || !phone || !role) {
      alert("All fields are required.");
      return;
    }

    let hasError = false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("**Please enter a valid email address.");
      hasError = true;
    } else {
      setEmailError("");
    }

    const phoneRegex = /^\+?[0-9]\d{1,19}$/;
    if (!phoneRegex.test(phone)) {
      setPhoneError("**Please enter a valid phone number.");
      hasError = true;
    } else {
      setPhoneError("");
    }

    if(hasError) {
      return;
    }

    const updatedContact = {
      name,
      position: role,
      email,
      phone,
    };
  
    try {
      setLoading(true);
      setError(null);
      setSuccessMessage(null);
  
      const response = await axiosInstance.put(`/supplier-contact/${contact.id}/`, updatedContact);

      onSave(response.data); 
      setTimeout(() => {
        onClose();
      }, 5);

    } catch (error) {
      setError(error.response?.data?.message || "An error occurred while updating the contact.");
    } finally {
      setLoading(false);
    }
  };
  
  if (!open) return null;

  return (
    <div className="contacts-overlay">
      <div className="contacts-popup">
        <h2 className="contacts-h2">Edit Person Contact</h2>
        
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        <form className="contacts-form">
          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Name<span className="contacts-required-star">*</span></label>
            <input
              className="contacts-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Role<span className="contacts-required-star">*</span></label>
            <input
              className="contacts-input"
              type="text"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            />
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Email<span className="contacts-required-star">*</span></label>
            <input
              className="contacts-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailError && <span className="contacts-error">{emailError}</span>}
          </div>

          <div className="contacts-inputGroup">
            <label className="contacts-label">
              Phone<span className="contacts-required-star">*</span></label>
            <input
              className="contacts-input"
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {phoneError && <span className="contacts-error">{phoneError}</span>}
          </div>

          <div className="contacts-buttons">
            <button type="button" className="contacts-button cancel" onClick={onClose}>
              Close
            </button>
            <button 
              type="button" 
              className="contacts-button save" 
              onClick={handleSubmit} 
              disabled={loading} 
            >
              Update Contact
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContacts;
